module.exports = __webpack_public_path__ + "2023394823c5eb32844e9c903411d14a.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/face-Phuong.png
// module id = 574
// module chunks = 30